<template>
  <div>
    <Report
      module="Estoque"
      name="Patrimonios"
      urlGet="/api/v1/stock/report/patrimony"
      :header="header"
      :filters="filters"
    />
  </div>
</template>

<script>
import Report from "@nixweb/nixloc-ui/src/component/report/Report";

export default {
  name: "ReportPatrimonyView",
  components: {
    Report,
  },
  data() {
    return {
      header: [
        {
          title: "Patrimonio",
          field: "barCode",
          fieldOrderBy: "BarCode",
          show: true,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Serie",
          field: "serialNumber",
          fieldOrderBy: "SerialNumber",
          show: true,
          styleHeader: "width:120px;",
          styleBody: "max-width: 110px;",
        },
        {
          title: "Produto",
          field: "fullName",
          fieldOrderBy: "FullName",
          show: true,
          initialOrderBy: true,
          styleHeader: "width:300px;",
          styleBody:
            "max-width: 290px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Categoria",
          field: "categoryProductName",
          fieldOrderBy: "CategoryProductName",
          show: false,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Fabricante",
          field: "manufacturerName",
          fieldOrderBy: "ManufacturerName",
          show: false,
          styleHeader: "width:160px;",
          styleBody:
            "max-width: 150px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
        {
          title: "Data Compra",
          field: "purchaseDate",
          fieldOrderBy: "PurchaseDate",
          show: false,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Status",
          field: "statusName",
          fieldOrderBy: "StatusName",
          show: true,
          styleHeader: "width:90px;",
          styleBody: "max-width: 80px;",
        },
        {
          title: "Nº Locacao",
          field: "numberRent",
          fieldOrderBy: "NumberRent",
          show: false,
          styleHeader: "width:100px;",
          styleBody: "max-width: 90px;",
        },
        {
          title: "Cliente",
          field: "customerName",
          fieldOrderBy: "CustomerName",
          show: false,
          styleHeader: "width:240px;",
          styleBody:
            "max-width: 230px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;",
        },
      ],
      filters: [
        {
          type: "text",
          title: "Patrimonio",
          field: "BarCode",
          value: "",
        },
        {
          type: "text",
          title: "Serie",
          field: "SerialNumber",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Tipo de Produto",
          field: "TypeProductName",
          url: "/api/v1/stock/type-product/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Produto",
          field: "FullName",
          url: "/api/v1/stock/product/select-all-with-typeProduct",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Categoria",
          field: "CategoryProductName",
          url: "/api/v1/stock/category-product/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "multiOptions",
          title: "Fabricante",
          field: "ManufacturerName",
          url: "/api/v1/stock/manufacturer/select-all",
          propsParams: {},
          value: "",
        },
        {
          type: "date",
          title: "Data Compra",
          field: "PurchaseDate",
          value: "",
          required: false,
        },
        {
          type: "options",
          title: "Status",
          field: "StatusName",
          options: [
            { text: "Disponivel", value: "Disponivel" },
            { text: "Locado", value: "Locado" },
            { text: "Manutencao", value: "Manutencao" },
            { text: "Inativo", value: "Inativo" },
          ],
          value: [],
        },
        {
          type: "text",
          title: "Nº Locacao",
          field: "NumberRent",
          value: "",
        },
        {
          type: "multiOptions",
          title: "Cliente",
          field: "CustomerName",
          url: "/api/v1/crm/customer/select-all-without-document",
          propsParams: { isCustomer: true, isSupplier: false },
          value: "",
        },
      ],
    };
  },
};
</script>
